module.exports = __webpack_public_path__ + "static/media/fuel5.dd3deeb0.svg";